import { createFileRoute } from '@tanstack/react-router';

import { CasesPage } from '../../../features/catalog/cases-page.tsx';
import { requirePermissionRoute } from '../../../lib/permissions.ts';

/** Открытый кейс живёт в адресе: ссылку можно переслать. */
interface CasesSearch {
  readonly case?: string | undefined;
}

export const Route = createFileRoute('/_app/catalog/cases')({
  validateSearch: (search: Record<string, unknown>): CasesSearch => ({
    case: typeof search.case === 'string' ? search.case : undefined,
  }),
  beforeLoad: requirePermissionRoute('catalog.read'),
  component: CasesRoute,
});

function CasesRoute() {
  const { case: caseId } = Route.useSearch();
  return <CasesPage caseId={caseId} />;
}
